import store from '@/store'
import { Action, Module, VuexModule } from 'vuex-module-decorators'
import { StatementNotificationService } from '../../services/modules/statement-notification.service'

@Module
export default class StatementNotificationStore extends VuexModule {
    @Action
    getStatementNotifications () {
        return new Promise((resolve) => {
            StatementNotificationService.getAll()
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    getStatementNotificationByProvider (providerId: number) {
        return new Promise((resolve) => {
            StatementNotificationService.getByProvider(providerId)
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    createStatementNotification (params: { providerId: number; emails: string; subject: string; body: string }) {
        return new Promise((resolve) => {
            StatementNotificationService.create(params)
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    updateStatementNotification (data: { id: number; params: { emails: string; subject: string; body: string } }) {
        return new Promise((resolve) => {
            StatementNotificationService.update(data.id, data.params)
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    deleteStatementNotification (id: number) {
        return new Promise((resolve) => {
            StatementNotificationService.delete(id)
                .then(resp => resolve(resp))
                .catch(error => {
                    store.commit('reportError', { code: 500, message: 'Error deleting notification' })
                    resolve(error.response)
                })
        })
    }

    @Action
    sendStatementNotification (statementId: number) {
        return new Promise((resolve) => {
            StatementNotificationService.send(statementId)
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    getStatementNotificationTemplate () {
        return new Promise((resolve) => {
            StatementNotificationService.getTemplate()
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }

    @Action
    saveStatementNotificationTemplate (params: { subject: string; body: string }) {
        return new Promise((resolve) => {
            StatementNotificationService.saveTemplate(params)
                .then(resp => resolve(resp))
                .catch(error => resolve(error.response))
        })
    }
}
